/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 25/10/2020
 */

let NewSessionCoachDialogView = () => import("./NewSessionCoachDialog")
let NewSessionClientDialogView = () => import("./NewSessionClientDialog")
let ExistingSessionClientDialog = () => import("./ExistingSessionClientDialog")
let ExistingSessionCoachDialog = () => import("./ExistingSessionCoachDialog")


// import NewSessionCoachDialogView from "./NewSessionCoachDialog"
// import NewSessionClientDialogView from "./NewSessionClientDialog"
// import ExistingSessionClientDialog from "./ExistingSessionClientDialog"
// import ExistingSessionCoachDialog from "./ExistingSessionCoachDialog"
import {createDialogLazy} from "@/utils/helpers-external.js";

export const newSessionCoachDialog = createDialogLazy(NewSessionCoachDialogView)
export const newSessionClientDialog = createDialogLazy(NewSessionClientDialogView)
export const existingSessionClientDialog = createDialogLazy(ExistingSessionClientDialog)
export const existingSessionCoachDialog = createDialogLazy(ExistingSessionCoachDialog)

